import { useSelector } from "react-redux";
import { getTrialInfo, getPaymentAmount } from "selectors/userInfo";
import { useState } from "react";
import { PAYMENT_CONFIG } from "constants/payment";
import { PaymentModal } from "../PaymentModal";
import {
	BannerContainer,
	TextContent,
	Title,
	Description,
	DaysCount,
	PayButton,
} from "./styledComponents";

/**
 * Получение правильного склонения слова "день"
 */
const getDaysWord = (days: number): string => {
	const absNum = Math.abs(days);
	const lastDigit = absNum % 10;
	const lastTwoDigits = absNum % 100;

	if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return "дней";
	if (lastDigit === 1) return "день";
	if (lastDigit >= 2 && lastDigit <= 4) return "дня";
	return "дней";
};

/**
 * Баннер информации о пробном периоде
 * Отображается для неоплаченных пользователей в течение 14 дней
 */
const TrialBanner = () => {
	const trialInfo = useSelector(getTrialInfo);
	const paymentAmount = useSelector(getPaymentAmount);
	const [showPaymentModal, setShowPaymentModal] = useState(false);

	// Использование демо-данных или реальных из Redux
	const daysRemaining = PAYMENT_CONFIG.DEMO_MODE
		? PAYMENT_CONFIG.DEMO_DAYS
		: trialInfo.daysRemaining;
	const isPayed = PAYMENT_CONFIG.DEMO_MODE
		? PAYMENT_CONFIG.DEMO_IS_PAYED
		: trialInfo.isPayed;

	// Не показываем баннер для оплативших пользователей
	if (isPayed) return null;

	// Не показываем этот баннер после окончания trial периода
	// (вместо него показывается блокирующий оверлей)
	if (daysRemaining <= 0) return null;

	const variant = daysRemaining <= 3 ? "warning" : "info";

	return (
		<>
			<BannerContainer variant={variant}>
				<TextContent>
					<Title>Бесплатный период</Title>
					<Description>
						У вас осталось{" "}
						<DaysCount variant={variant}>
							{daysRemaining} {getDaysWord(daysRemaining)}
						</DaysCount>{" "}
						бесплатного доступа к обучающим материалам.{" "}
						<a
							href="https://notifications.hb.ru-msk.vkcloud-storage.ru/%D0%A3%D0%B2%D0%B5%D0%B4%D0%BE%D0%BC%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5_%D0%BE%D0%B1%D1%83%D1%87%D0%B0%D1%8E%D1%89%D0%B8%D1%85%D1%81%D1%8F_%D0%BE_%D0%B2%D0%B2%D0%B5%D0%B4%D0%B5%D0%BD%D0%B8%D0%B8_%D0%BF%D0%BB%D0%B0%D1%82%D1%8B_%D0%B7%D0%B0_%D0%B8%D0%B4%D0%B5%D0%BD%D1%82%D0%B8%D1%84%D0%B8%D0%BA%D0%B0%D1%86%D0%B8%D1%8E.pdf"
							target="_blank"
							rel="noopener noreferrer"
						>
							За что и почему я оплачиваю?
						</a>
					</Description>
				</TextContent>
				<PayButton
					buttonTheme={variant === "warning" ? "warning" : "primary"}
					onClick={() => setShowPaymentModal(true)}
				>
					Оплатить {paymentAmount.toLocaleString("ru-RU")} ₽
				</PayButton>
			</BannerContainer>

			{showPaymentModal && (
				<PaymentModal
					variant="confirm"
					title="Оформление доступа"
					description="Оплатите доступ для продолжения обучения после окончания бесплатного периода"
					onClose={() => setShowPaymentModal(false)}
				/>
			)}
		</>
	);
};

export default TrialBanner;
